import { render, staticRenderFns } from "./AValueInput.vue?vue&type=template&id=0b6571a6&scoped=true&"
import script from "./AValueInput.vue?vue&type=script&lang=ts&"
export * from "./AValueInput.vue?vue&type=script&lang=ts&"
import style0 from "./AValueInput.vue?vue&type=style&index=0&id=0b6571a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6571a6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
